import Vue from 'vue'
import store from '@/store'
import { deepClone } from '@/util'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import Login from '@/components/Login'
import MainLayout from '@/components/layout/MainLayout'



import ArticleViewContent from '@/components/invite/ArticleViewContent';
import PointHistory from '@/components/invite/PointHistory';

import Index from '@/components/Index'
import ExchangeCode from '@/components/components/ExchangeCode'
import Transpond from '@/components/Transpond'
import CreateCdkey from "@/components/pages/CreateCdkey";
import MyCustomer from '@/components/pages/MyCustomer'
import MyProfit from '@/components/pages/MyProfit'
/*
import CreateArticle from '@/components/invite/CreateArticle';
import ArticleViewDetail from '@/components/invite/ArticleViewDetail';
import MyProduct from '@/components/pages/MyProduct'
import MyCdkeyNew from '@/components/pages/MyCdkeyNew'

import SpreadArticleList from '@/components/pages/SpreadArticleList'
import MyCourses from '@/components/pages/MyCourses'
import Information from "@/components/pages/Information";
import ProcessSystem from '@/components/pages/ProcessSystem'
import ServiceSupport from '@/components/pages/ServiceSupport'
import APICustomer from '@/components/pages/APICustomer';
import ComboList from '@/components/pages/ComboList';
import ComboDetail from '@/components/pages/ComboDetail';
import CreatePoster from "@/components/invite/CreatePoster";
import CustomProfit from '@/components/pages/CustomProfit';
import ProductChange from '@/components/pages/ProductChange';
import CompanyDes from '@/components/pages/CompanyDes';
import ProductDes from '@/components/pages/ProductDes'
import TemplateDes from '@/components/pages/TemplateDes'
*/

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
};

// 动态路由（异步路由、导航栏路由）
/*
* activeNav 指定高亮侧边栏路由，需要设置完整路由地址
* noShowMenu 该路由是否在侧边栏导航中展示 为true 则不显示在左边导航栏 false或者不设置则会显示在左边导航栏
* breadcrumb 该路由是否在面包屑导航中展示
* auth 权限标识
* */
const asyncRoutes = [
  {
    path: '/main',
    component: MainLayout,
    name: '我的首页',
    redirect: '/main.html',
    meta: {
      icon: 'indexIcon',
    },
    children: [
      {
        path: '/main.html',
        component: Index,
        name: '首页',
        meta: {
          icon: 'indexIcon',
          activeNav: '/main',
          breadcrumb: false,
          noShowMenu: true,
        }
      },
    ]
  },
  /*
    {
      path: '',
      component: MainLayout,
      name: '产品管理',
      meta: {
        icon: 'productIcon',
      },
      children: [
        {
          name: '我的产品',
          path: '/pages/myProduct.html',
          component: MyProduct,
          meta: {
            icon: '',
            activeNav: '/pages/myProduct.html',
          }
        },
        {
          name: '产品调换记录',
          path: '/pages/productChange.html',
          component: ProductChange,
          meta: {
            icon: '',
            activeNav: '/pages/productChange.html'
          }
        },
      ]
    },
  */
  {
    path: '',
    component: MainLayout,
    name: '我要推广',
    meta: {
      icon: 'cdkeyIcon'
    },
    children: [
      {
        name: '我的兑换码',
        path: '/pages/ExchangeCode.html',
        component: ExchangeCode,
        meta: {
          icon: '',
          activeNav: '/pages/ExchangeCode.html'
        },
        children: [
          {
            name: '生成兑换码',
            path: '/pages/createCdkey.html',
            component: CreateCdkey,
            meta: {
              icon: '',
              activeNav: '/pages/ExchangeCode.html',
              noShowMenu: true
            }
          }
        ]
      },
      /*
      {
        name: '我的海报',
        path: '/pages/SpreadArticleList.html',
        component: SpreadArticleList,
        meta: {
          icon: '',
          activeNav: '/pages/SpreadArticleList.html'
        },
        children: [
          {
            name: '海报详情',
            path: '/invite/articleDetail.html',
            component: ArticleViewDetail,
            meta: {
              icon: '',
              activeNav: '/pages/SpreadArticleList.html',
              noShowMenu: true
            }
          },
          {
            name: '制作推广海报',
            path: '/pages/myPoster.html',
            component: CreatePoster,
            meta: {
              icon: '',
              activeNav: '/pages/SpreadArticleList.html',
              noShowMenu: true
            }
          }
        ]
      },
      */
    ]
  },
  {
    path: '',
    component: MainLayout,
    name: '我的客户',
    meta: {
      icon: 'clientIcon'
    },
    children: [
      {
        name: '标准产品客户',
        path: '/pages/myCustomer.html',
        component: MyCustomer,
        meta: {
          icon: '',
          activeNav: '/pages/myCustomer.html'
        },
        children: [
          {
            name: '积分明细',
            path: '/invite/pointHistory.html',
            component: PointHistory,
            meta: {
              icon: '',
              activeNav: '/pages/myCustomer.html',
              noShowMenu: true
            }
          }
        ]
      },
      /*
       {
        name: '定制产品客户',
        path: '/pages/APICustomer.html',
        component: APICustomer,
        meta: {
          icon: '',
          activeNav: '/pages/APICustomer.html'
        },
        children: [
          {
            name: '套餐详情',
            path: '/pages/ComboList.html',
            component: ComboList,
            meta: {
              icon: '',
              activeNav: '/pages/APICustomer.html',
              noShowMenu: true,
            },
            children: [
              {
                name: '使用详情',
                path: '/pages/ComboDetail.html',
                component: ComboDetail,
                meta: {
                  icon: '',
                  activeNav: '/pages/APICustomer.html',
                  noShowMenu: true
                }
              }
            ]
          }
        ]
      },
       */
    ]
  },
  {
    name: '我的收益',
    path: '',
    component: MainLayout,
    meta: {
      icon: 'earningsIcon',
    },
    children: [
      {
        name: '标准产品收益',
        path: '/pages/myProfit.html',
        component: MyProfit,
        meta: {
          icon: '',
          activeNav: '/pages/myProfit.html',
        }
      },
      /*
      {
        name: '定制产品收益',
        path: '/pages/customProfit.html',
        component: CustomProfit,
        meta: {
          icon: '',
          activeNav: '/pages/customProfit.html',
        }
      },
      */
    ]
  },
  /*
  {
    name: '服务支持',
    path: '',
    component: MainLayout,
    meta: {
      icon: 'serveIcon',
    },
    children: [
      {
        name: '公司介绍',
        path: '/pages/CompanyDes.html',
        component: CompanyDes,
        meta: {
          icon: '',
          activeNav: '/pages/CompanyDes.html',
        }
      },
      {
        name: '产品介绍',
        path: '/pages/ProductDes.html',
        component: ProductDes,
        meta: {
          icon: '',
          activeNav: '/pages/ProductDes.html',
        }
      },
      {
        name: '合同模板',
        path: '/pages/TemplateDes.html',
        component: TemplateDes,
        meta: {
          icon: '',
          activeNav: '/pages/TemplateDes.html',
        }
      },
    ]
  },
  */
];

const router = new Router({
  mode: 'history',
  routes: [
    // 固定路由
    {
      path: '/',
      redirect: '/main.html',
      hidden: true
    },
    {
      path: '/index.html',
      redirect: '/main.html',
      hidden: true
    },
    {
      path: '/login.html',
      name: '登录',
      component: Login,
      meta: {
        noNeedLogin: true
      },
      hidden: true
    },
    {
      path: '/transpond.html',
      name: '兑换码',
      component: Transpond,
      meta: {
        noNeedLogin: true
      },
      hidden: true
    },
    {
      path: '/invite/articleViewContent.html',
      name: '浏览文章详情',
      component: ArticleViewContent,
      meta: {
        noNeedLogin: true
      },
      hidden: true
    },
    // 404页面
    {
      path: '*',
      component: () => import('@/components/layout/404.vue')
    }
  ]
});

NProgress.configure({
  showSpinner: false
})
router.beforeEach(async (to, from, next) => {
  NProgress.start()

  //判断是否登陆
  if (JSON.parse(localStorage.getItem("userinfo"))) {
    // 是否已动态生成并挂载路由
    if (store.state.isGenerate) {
      next()
    }
    else {
      //处理理由
      let Routes = await store.dispatch('generateRoutesAtFront', asyncRoutes);
      //添加路由
      // Routes.forEach(route=>{
      //   router.addRoute(route);
      // });
      router.addRoutes(Routes);
      store.commit('setIsGenerate', true);
      next({ ...to, replace: true })
    }
  }
  else {
    if (to.path != '/login.html') {
      if (to.meta.noNeedLogin) {
        next()
      }
      else {
        next({
          path: '/login.html',
        })
      }
    } else {
      next()
    }
  }


});
router.afterEach(transition => {
  NProgress.done()
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js